import { CommonModule } from '@angular/common';
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { PaymentService } from '@app/payments/services/payment.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
   selector: 'app-payment-rent-and-charges',
   templateUrl: './payment-rent-and-charges.html',
   imports: [CommonModule, SpinnerComponent],
    providers: [ PaymentService ]
})
export class PaymentRentAndChargesComponent implements OnInit, OnDestroy {
   public showBalanceServiceNotAvailable = new BehaviorSubject<boolean>(false);
   public showBalanceNotAvailable = new BehaviorSubject<boolean>(false);
   public isArrear = new BehaviorSubject<boolean>(false);
   public isCredit = new BehaviorSubject<boolean>(false);
    public balanceText = new BehaviorSubject<string>("");

   loading: boolean = false;
    inArrears = "";
    inCredit = "";
    heading = "";
    icon = "";
    primaryButtonText = "";
    primaryButtonLink = "";
   showPrimaryButton = false;
    secondaryButtonText = "";
    secondaryButtonLink = "";
   showSecondaryButton = false;
    index = "";
    balanceServiceNotAvailable = "";
    balanceNotAvailable = "";
   primaryButtonEnabled = true;
   secondaryButtonEnabled = false;
   showAdditionalSummary = false;
    additionalSummaryText = "";

   private destroy$ = new Subject<void>();

   constructor(
      private paymentsService: PaymentService,
      private el: ElementRef,
        private adb2cService: Adb2cService
   ) {}

   ngOnInit(): void {
      this.loading = true;
      const cpt = this.el.nativeElement;

        this.inArrears = cpt.getAttribute("inArrears");
        this.inCredit = cpt.getAttribute("inCredit");
        this.heading = cpt.getAttribute("heading");
        this.icon = cpt.getAttribute("icon");
        this.primaryButtonText = cpt.getAttribute("primaryButtonText");
        this.primaryButtonLink = cpt.getAttribute("primaryButtonLink");
        this.secondaryButtonText = cpt.getAttribute("secondaryButtonText");
        this.secondaryButtonLink = cpt.getAttribute("secondaryButtonLink");
        this.index = cpt.getAttribute("index");
        this.balanceServiceNotAvailable = cpt.getAttribute("balanceServiceNotAvailable");
        this.balanceNotAvailable = cpt.getAttribute("balanceNotAvailable");
        this.primaryButtonEnabled = cpt.getAttribute("primaryButtonEnabled") !== "false";
        this.showAdditionalSummary = cpt.getAttribute("showAdditionalSummary") === "true";
        this.additionalSummaryText = cpt.getAttribute("additionalSummaryText");

      this.showSecondaryButton = this.secondaryButtonLink != "" && this.secondaryButtonLink != null && this.secondaryButtonLink != undefined;
      this.showPrimaryButton = this.primaryButtonLink != "";

      this.adb2cService.getUser();
        this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.paymentsService.getBalance(user[ 'tenancy_reference' ], 0).subscribe({
                  next: (response) => {
                     if (response && response.body) {
                        if (response.body.balance > 0) {
                           this.isCredit.next(true);
                           this.secondaryButtonEnabled = true;
                            }
                            else if (response.body.balance < 0) {
                           this.isArrear.next(true);
                           this.secondaryButtonEnabled = true;
                        }
                        this.balanceText.next(this.paymentsService.convertToCurrencyText(response.body.balance, true));
                        this.loading = false;
                     }
                  },
                  error: (error) => {
                     console.log(error);
                     this.loading = false;

                     if (error.status === 404) {
                        this.showBalanceNotAvailable.next(true);
                        }
                        else {
                        this.showBalanceServiceNotAvailable.next(true);
                     }
                  },
               });
            }
         });
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();

      //clean up the subjects to free up some memory
      this.showBalanceServiceNotAvailable.complete();
      this.showBalanceNotAvailable.complete();
      this.isArrear.complete();
      this.isCredit.complete();
      this.balanceText.complete();
   }
}
